export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_ADMIN = 'SET_ADMIN';
export const SET_EMAIL_CONFIRMED = 'SET_EMAIL_CONFIRMED';
export const SET_STATUS = 'SET_STATUS';
export const SET_LOADING = 'SET_LOADING';
